import { Controller } from "@hotwired/stimulus"
import tomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    allowBlank: { type: Boolean, default: false }
  }
  connect() {
    new tomSelect(this.element, {
      allowEmptyOption: this.allowBlankValue,
      create: true,
      controlInput: null,
      plugins: ['input_autogrow']
    });
  }
}
